import axios from "axios";
import { errorMessage } from "./toastifyShowMessage";
import { HandleServicesError } from "./swalModal";
import { CheckToken, clearApp, clearAuthOnly, getLocalStorage, setAuthorization, setToken } from "./services";
import { _ckey } from "../address";
import { delay } from "./tools";
// ساختار دریافت و پست کردن دیتا
export const QueryAPI = async ({ url = "", parameters = {}, type = "post", contentType = "application/json; charset=utf-8", signal }) => {
	let response = null;
	setAuthorization(getLocalStorage(_ckey.token));
	try {
		const apiUrl = process.env.REACT_APP_API_KEY + url;
		if (type === "post") {
			response = await axios.post(apiUrl, parameters, { signal, timeout: 30000, headers: { "Content-Type": contentType } });
		} else {
			response = await axios.get(apiUrl, { signal, timeout: 30000 });
		}
		if (response.data.HasError) {
			errorMessage(response.data.Message);
			return null;
		}
	} catch (error) {
		if (error?.response?.status === 401) {
			try {
				// ⬇️ به‌جای پاک‌کردن همه‌چیز، اول رفرش کن
				const ok = await CheckToken();
				if (ok) {
					// ⬇️ یک‌بار دیگر همان ریکوئست را تکرار کن
					const apiUrl = process.env.REACT_APP_API_KEY + url;
					if (type === "post") {
						response = await axios.post(apiUrl, parameters, { signal, timeout: 30000, headers: { "Content-Type": contentType } });
					} else {
						response = await axios.get(apiUrl, { signal, timeout: 30000 });
					}
				} else {
					// ⬇️ فقط احراز هویت را پاک کن؛ ویزاردها/پرسیست دست نخورند
					clearAuthOnly();
					window.location.href = "/";
					return null;
				}
			} catch {
				clearAuthOnly();
				window.location.href = "/";
				return null;
			}
		} else {
			if (process.env.REACT_APP_DOMAIN === "dealer") {
				errorMessage(
					<div dir="ltr" style={{ textAlign: "left" }}>
						{error?.code} <br />
						{error?.message} <br />
						{error?.config?.url} <br />
					</div>,
				);
			} else {
				errorMessage("درحال حاضر سرویس در دسترس نمی‌باشد");
			}
			return null;
		}
	}
	return response ? response.data : null;
};

export * from "./api/public";
export * from "./api/security";
export * from "./api/report";
export * from "./api/crm";
export * from "./api/dealer";
